import { render, staticRenderFns } from "./proBoardMain.vue?vue&type=template&id=6e7ce66a&scoped=true"
import script from "./proBoardMain.vue?vue&type=script&lang=js"
export * from "./proBoardMain.vue?vue&type=script&lang=js"
import style0 from "./proBoardMain.vue?vue&type=style&index=0&id=6e7ce66a&prod&lang=scss&scoped=true"
import style1 from "./proBoardMain.vue?vue&type=style&index=1&id=6e7ce66a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7ce66a",
  null
  
)

export default component.exports